// src/pages/restaurant/RestaurantPage.tsx
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaUtensils } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import LoadingSpinner from "~/components/ui/LoadingSpinner";
import { useBranch } from "~/contexts/BranchContext";
import RestaurantHeader from "~/templates/modern/restaurant/components/RestaurantHeader";
import ModernRestaurantPage from "~/templates/modern/restaurant/ModerRestaurantPage";
import NotFoundPage from "../not-found/NotFoundPage";

const RestaurantPage = () => {
  const { t } = useTranslation();
  const { branchData, isLoading, error } = useBranch();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size={4} message={t("restaurant.loading")} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <NotFoundPage />
      </div>
    );
  }

  if (!branchData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="text-red-600 text-6xl mb-4"
          >
            <FaUtensils />
          </motion.div>
          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.1 }}
            className="text-2xl font-bold mb-2"
          >
            {t("restaurant.notFound.title")}
          </motion.h1>
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-gray-600 mb-6"
          >
            {t("restaurant.notFound.message")}
          </motion.p>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <Link to="/">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer"
              >
                {t("restaurant.notFound.homeButton")}
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* You can switch between templates based on restaurant.theme.template */}

      <RestaurantHeader />
      <ModernRestaurantPage branchData={branchData} />
    </>
  );
};

export default RestaurantPage;
